import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { GetOutputTargetResponce } from "./api-services/get-output-target.service";
import { KYMW7403Component } from "./kymw7403.component";
import { ConfirmData } from "./vo/confirm-data.model";

export class KYMW7403Model {
  kymw7403Component: KYMW7403Component;

  /** 出力対象　セレクトボックス表示 */
  confirmList: Array<any> = new Array();

  // 商品リスト出力
  /** 出力対象データ */
  confirmDataId: string = <string>'';
  /** 出力対象企画回 */
  catalogId: string = <string>'';
  /** 8週先 */
  aheadEightWeeks: any = <boolean>false;
  /** 承認待ちを含む */
  includeUnapproval: any = <boolean>false;

  // 比較リスト出力
  /** 出力対象データ */
  confirmDataDiff: string = <string>'';
  /** 出力対象企画回 */
  catalogIdDiff: string = <string>'';
  /** 比較対象データ */
  comparingData: string = <string>'';
  /** 比較対象企画回 */ 
  comparingCatalogId: string = <string>''; 

  /** 
   * セレクトボックス「出力対象データ」を設定
   * 
   */
  public setConfirmList(serverData: GetOutputTargetResponce) {
    // 「現在のデータ」をリストに追加
    const templist = [
      { confirmDate: '',
        confirmUserId: '',
        confirmUserName: '',
        caption: '現在のデータ',
        id: '0',
      }
    ];
    
    // レスポンスデータを表示用に整形
    serverData.forEach( (item, index) => {
      let tempData = new ConfirmData();
      tempData.confirmDate = item.ConfirmDate;
      tempData.confirmUserId = item.ConfirmUserId;
      tempData.confirmUserName = item.ConfirmUserName;
      tempData.caption = '確定データ(' + PlessViewUtilsSub.dateToString(new Date(tempData.confirmDate), 'YYYY-MM-DD hh:mm')
                       + ' 確定者:' + item.ConfirmUserName + ')';
      tempData.id = PlessViewUtilsSub.numberToString(index + 1);  // 「現在のデータ」を0とする
      templist.push(tempData);
    });

    this.confirmList = templist;

    // 初期値：現在のデータ
    this.confirmDataId = '0';
    this.confirmDataDiff = '0';
    this.comparingData = '0';
  }
}